export const COUNTRIES_PASHA = {
  '@context': '/api/contexts/CountryInfo',
  '@id': '/api/client/geo/country',
  '@type': 'Collection',
  totalItems: 249,
  member: [
    {
      '@id': '/api/country_infos/0',
      '@type': 'CountryInfo',
      id: 0,
      countryName: 'United States of America (the)',
      alpha2Code: 'US',
      numericCode: '840',
    },
    {
      '@id': '/api/country_infos/1',
      '@type': 'CountryInfo',
      id: 1,
      countryName: 'Argentina',
      alpha2Code: 'AR',
      numericCode: '032',
    },
    {
      '@id': '/api/country_infos/2',
      '@type': 'CountryInfo',
      id: 2,
      countryName: 'Brazil',
      alpha2Code: 'BR',
      numericCode: '076',
    },
    {
      '@id': '/api/country_infos/3',
      '@type': 'CountryInfo',
      id: 3,
      countryName: 'Canada',
      alpha2Code: 'CA',
      numericCode: '124',
    },
    {
      '@id': '/api/country_infos/4',
      '@type': 'CountryInfo',
      id: 4,
      countryName: 'Chile',
      alpha2Code: 'CL',
      numericCode: '152',
    },
    {
      '@id': '/api/country_infos/5',
      '@type': 'CountryInfo',
      id: 5,
      countryName: 'Colombia',
      alpha2Code: 'CO',
      numericCode: '170',
    },
    {
      '@id': '/api/country_infos/6',
      '@type': 'CountryInfo',
      id: 6,
      countryName: 'Costa Rica',
      alpha2Code: 'CR',
      numericCode: '188',
    },
    {
      '@id': '/api/country_infos/7',
      '@type': 'CountryInfo',
      id: 7,
      countryName: 'El Salvador',
      alpha2Code: 'SV',
      numericCode: '222',
    },
    {
      '@id': '/api/country_infos/8',
      '@type': 'CountryInfo',
      id: 8,
      countryName: 'France',
      alpha2Code: 'FR',
      numericCode: '250',
    },
    {
      '@id': '/api/country_infos/9',
      '@type': 'CountryInfo',
      id: 9,
      countryName: 'Germany',
      alpha2Code: 'DE',
      numericCode: '276',
    },
    {
      '@id': '/api/country_infos/10',
      '@type': 'CountryInfo',
      id: 10,
      countryName: 'Guatemala',
      alpha2Code: 'GT',
      numericCode: '320',
    },
    {
      '@id': '/api/country_infos/11',
      '@type': 'CountryInfo',
      id: 11,
      countryName: 'Honduras',
      alpha2Code: 'HN',
      numericCode: '340',
    },
    {
      '@id': '/api/country_infos/12',
      '@type': 'CountryInfo',
      id: 12,
      countryName: 'Ireland',
      alpha2Code: 'IE',
      numericCode: '372',
    },
    {
      '@id': '/api/country_infos/13',
      '@type': 'CountryInfo',
      id: 13,
      countryName: 'Mexico',
      alpha2Code: 'MX',
      numericCode: '484',
    },
    {
      '@id': '/api/country_infos/14',
      '@type': 'CountryInfo',
      id: 14,
      countryName: 'Nicaragua',
      alpha2Code: 'NI',
      numericCode: '558',
    },
    {
      '@id': '/api/country_infos/15',
      '@type': 'CountryInfo',
      id: 15,
      countryName: 'Panama',
      alpha2Code: 'PA',
      numericCode: '591',
    },
    {
      '@id': '/api/country_infos/16',
      '@type': 'CountryInfo',
      id: 16,
      countryName: 'Peru',
      alpha2Code: 'PE',
      numericCode: '604',
    },
    {
      '@id': '/api/country_infos/17',
      '@type': 'CountryInfo',
      id: 17,
      countryName: 'United Kingdom of Great Britain and Northern Ireland (the)',
      alpha2Code: 'GB',
      numericCode: '826',
    },
    {
      '@id': '/api/country_infos/18',
      '@type': 'CountryInfo',
      id: 18,
      countryName: 'Afghanistan',
      alpha2Code: 'AF',
      numericCode: '004',
    },
    {
      '@id': '/api/country_infos/19',
      '@type': 'CountryInfo',
      id: 19,
      countryName: 'Albania',
      alpha2Code: 'AL',
      numericCode: '008',
    },
    {
      '@id': '/api/country_infos/20',
      '@type': 'CountryInfo',
      id: 20,
      countryName: 'Algeria',
      alpha2Code: 'DZ',
      numericCode: '012',
    },
    {
      '@id': '/api/country_infos/21',
      '@type': 'CountryInfo',
      id: 21,
      countryName: 'American Samoa',
      alpha2Code: 'AS',
      numericCode: '016',
    },
    {
      '@id': '/api/country_infos/22',
      '@type': 'CountryInfo',
      id: 22,
      countryName: 'Andorra',
      alpha2Code: 'AD',
      numericCode: '020',
    },
    {
      '@id': '/api/country_infos/23',
      '@type': 'CountryInfo',
      id: 23,
      countryName: 'Angola',
      alpha2Code: 'AO',
      numericCode: '024',
    },
    {
      '@id': '/api/country_infos/24',
      '@type': 'CountryInfo',
      id: 24,
      countryName: 'Anguilla',
      alpha2Code: 'AI',
      numericCode: '660',
    },
    {
      '@id': '/api/country_infos/25',
      '@type': 'CountryInfo',
      id: 25,
      countryName: 'Antarctica',
      alpha2Code: 'AQ',
      numericCode: '010',
    },
    {
      '@id': '/api/country_infos/26',
      '@type': 'CountryInfo',
      id: 26,
      countryName: 'Antigua and Barbuda',
      alpha2Code: 'AG',
      numericCode: '028',
    },
    {
      '@id': '/api/country_infos/27',
      '@type': 'CountryInfo',
      id: 27,
      countryName: 'Armenia',
      alpha2Code: 'AM',
      numericCode: '051',
    },
    {
      '@id': '/api/country_infos/28',
      '@type': 'CountryInfo',
      id: 28,
      countryName: 'Aruba',
      alpha2Code: 'AW',
      numericCode: '533',
    },
    {
      '@id': '/api/country_infos/29',
      '@type': 'CountryInfo',
      id: 29,
      countryName: 'Australia',
      alpha2Code: 'AU',
      numericCode: '036',
    },
    {
      '@id': '/api/country_infos/30',
      '@type': 'CountryInfo',
      id: 30,
      countryName: 'Austria',
      alpha2Code: 'AT',
      numericCode: '040',
    },
    {
      '@id': '/api/country_infos/31',
      '@type': 'CountryInfo',
      id: 31,
      countryName: 'Azerbaijan',
      alpha2Code: 'AZ',
      numericCode: '031',
    },
    {
      '@id': '/api/country_infos/32',
      '@type': 'CountryInfo',
      id: 32,
      countryName: 'Bahamas (the)',
      alpha2Code: 'BS',
      numericCode: '044',
    },
    {
      '@id': '/api/country_infos/33',
      '@type': 'CountryInfo',
      id: 33,
      countryName: 'Bahrain',
      alpha2Code: 'BH',
      numericCode: '048',
    },
    {
      '@id': '/api/country_infos/34',
      '@type': 'CountryInfo',
      id: 34,
      countryName: 'Bangladesh',
      alpha2Code: 'BD',
      numericCode: '050',
    },
    {
      '@id': '/api/country_infos/35',
      '@type': 'CountryInfo',
      id: 35,
      countryName: 'Barbados',
      alpha2Code: 'BB',
      numericCode: '052',
    },
    {
      '@id': '/api/country_infos/36',
      '@type': 'CountryInfo',
      id: 36,
      countryName: 'Belarus',
      alpha2Code: 'BY',
      numericCode: '112',
    },
    {
      '@id': '/api/country_infos/37',
      '@type': 'CountryInfo',
      id: 37,
      countryName: 'Belgium',
      alpha2Code: 'BE',
      numericCode: '056',
    },
    {
      '@id': '/api/country_infos/38',
      '@type': 'CountryInfo',
      id: 38,
      countryName: 'Belize',
      alpha2Code: 'BZ',
      numericCode: '084',
    },
    {
      '@id': '/api/country_infos/39',
      '@type': 'CountryInfo',
      id: 39,
      countryName: 'Benin',
      alpha2Code: 'BJ',
      numericCode: '204',
    },
    {
      '@id': '/api/country_infos/40',
      '@type': 'CountryInfo',
      id: 40,
      countryName: 'Bermuda',
      alpha2Code: 'BM',
      numericCode: '060',
    },
    {
      '@id': '/api/country_infos/41',
      '@type': 'CountryInfo',
      id: 41,
      countryName: 'Bhutan',
      alpha2Code: 'BT',
      numericCode: '064',
    },
    {
      '@id': '/api/country_infos/42',
      '@type': 'CountryInfo',
      id: 42,
      countryName: 'Bolivia (Plurinational State of)',
      alpha2Code: 'BO',
      numericCode: '068',
    },
    {
      '@id': '/api/country_infos/43',
      '@type': 'CountryInfo',
      id: 43,
      countryName: 'Bonaire, Sint Eustatius and Saba',
      alpha2Code: 'BQ',
      numericCode: '535',
    },
    {
      '@id': '/api/country_infos/44',
      '@type': 'CountryInfo',
      id: 44,
      countryName: 'Bosnia and Herzegovina',
      alpha2Code: 'BA',
      numericCode: '070',
    },
    {
      '@id': '/api/country_infos/45',
      '@type': 'CountryInfo',
      id: 45,
      countryName: 'Botswana',
      alpha2Code: 'BW',
      numericCode: '072',
    },
    {
      '@id': '/api/country_infos/46',
      '@type': 'CountryInfo',
      id: 46,
      countryName: 'Bouvet Island',
      alpha2Code: 'BV',
      numericCode: '074',
    },
    {
      '@id': '/api/country_infos/47',
      '@type': 'CountryInfo',
      id: 47,
      countryName: 'British Indian Ocean Territory (the)',
      alpha2Code: 'IO',
      numericCode: '086',
    },
    {
      '@id': '/api/country_infos/48',
      '@type': 'CountryInfo',
      id: 48,
      countryName: 'Brunei Darussalam',
      alpha2Code: 'BN',
      numericCode: '096',
    },
    {
      '@id': '/api/country_infos/49',
      '@type': 'CountryInfo',
      id: 49,
      countryName: 'Bulgaria',
      alpha2Code: 'BG',
      numericCode: '100',
    },
    {
      '@id': '/api/country_infos/50',
      '@type': 'CountryInfo',
      id: 50,
      countryName: 'Burkina Faso',
      alpha2Code: 'BF',
      numericCode: '854',
    },
    {
      '@id': '/api/country_infos/51',
      '@type': 'CountryInfo',
      id: 51,
      countryName: 'Burundi',
      alpha2Code: 'BI',
      numericCode: '108',
    },
    {
      '@id': '/api/country_infos/52',
      '@type': 'CountryInfo',
      id: 52,
      countryName: 'Cabo Verde',
      alpha2Code: 'CV',
      numericCode: '132',
    },
    {
      '@id': '/api/country_infos/53',
      '@type': 'CountryInfo',
      id: 53,
      countryName: 'Cambodia',
      alpha2Code: 'KH',
      numericCode: '116',
    },
    {
      '@id': '/api/country_infos/54',
      '@type': 'CountryInfo',
      id: 54,
      countryName: 'Cameroon',
      alpha2Code: 'CM',
      numericCode: '120',
    },
    {
      '@id': '/api/country_infos/55',
      '@type': 'CountryInfo',
      id: 55,
      countryName: 'Cayman Islands (the)',
      alpha2Code: 'KY',
      numericCode: '136',
    },
    {
      '@id': '/api/country_infos/56',
      '@type': 'CountryInfo',
      id: 56,
      countryName: 'Central African Republic (the)',
      alpha2Code: 'CF',
      numericCode: '140',
    },
    {
      '@id': '/api/country_infos/57',
      '@type': 'CountryInfo',
      id: 57,
      countryName: 'Chad',
      alpha2Code: 'TD',
      numericCode: '148',
    },
    {
      '@id': '/api/country_infos/58',
      '@type': 'CountryInfo',
      id: 58,
      countryName: 'China',
      alpha2Code: 'CN',
      numericCode: '156',
    },
    {
      '@id': '/api/country_infos/59',
      '@type': 'CountryInfo',
      id: 59,
      countryName: 'Christmas Island',
      alpha2Code: 'CX',
      numericCode: '162',
    },
    {
      '@id': '/api/country_infos/60',
      '@type': 'CountryInfo',
      id: 60,
      countryName: 'Cocos (Keeling) Islands (the)',
      alpha2Code: 'CC',
      numericCode: '166',
    },
    {
      '@id': '/api/country_infos/61',
      '@type': 'CountryInfo',
      id: 61,
      countryName: 'Comoros (the)',
      alpha2Code: 'KM',
      numericCode: '174',
    },
    {
      '@id': '/api/country_infos/62',
      '@type': 'CountryInfo',
      id: 62,
      countryName: 'Congo (the Democratic Republic of the)',
      alpha2Code: 'CD',
      numericCode: '180',
    },
    {
      '@id': '/api/country_infos/63',
      '@type': 'CountryInfo',
      id: 63,
      countryName: 'Congo (the)',
      alpha2Code: 'CG',
      numericCode: '178',
    },
    {
      '@id': '/api/country_infos/64',
      '@type': 'CountryInfo',
      id: 64,
      countryName: 'Cook Islands (the)',
      alpha2Code: 'CK',
      numericCode: '184',
    },
    {
      '@id': '/api/country_infos/65',
      '@type': 'CountryInfo',
      id: 65,
      countryName: 'Croatia',
      alpha2Code: 'HR',
      numericCode: '191',
    },
    {
      '@id': '/api/country_infos/66',
      '@type': 'CountryInfo',
      id: 66,
      countryName: 'Cuba',
      alpha2Code: 'CU',
      numericCode: '192',
    },
    {
      '@id': '/api/country_infos/67',
      '@type': 'CountryInfo',
      id: 67,
      countryName: 'Curaçao',
      alpha2Code: 'CW',
      numericCode: '531',
    },
    {
      '@id': '/api/country_infos/68',
      '@type': 'CountryInfo',
      id: 68,
      countryName: 'Cyprus',
      alpha2Code: 'CY',
      numericCode: '196',
    },
    {
      '@id': '/api/country_infos/69',
      '@type': 'CountryInfo',
      id: 69,
      countryName: 'Czechia',
      alpha2Code: 'CZ',
      numericCode: '203',
    },
    {
      '@id': '/api/country_infos/70',
      '@type': 'CountryInfo',
      id: 70,
      countryName: "Côte d'Ivoire",
      alpha2Code: 'CI',
      numericCode: '384',
    },
    {
      '@id': '/api/country_infos/71',
      '@type': 'CountryInfo',
      id: 71,
      countryName: 'Denmark',
      alpha2Code: 'DK',
      numericCode: '208',
    },
    {
      '@id': '/api/country_infos/72',
      '@type': 'CountryInfo',
      id: 72,
      countryName: 'Djibouti',
      alpha2Code: 'DJ',
      numericCode: '262',
    },
    {
      '@id': '/api/country_infos/73',
      '@type': 'CountryInfo',
      id: 73,
      countryName: 'Dominica',
      alpha2Code: 'DM',
      numericCode: '212',
    },
    {
      '@id': '/api/country_infos/74',
      '@type': 'CountryInfo',
      id: 74,
      countryName: 'Dominican Republic (the)',
      alpha2Code: 'DO',
      numericCode: '214',
    },
    {
      '@id': '/api/country_infos/75',
      '@type': 'CountryInfo',
      id: 75,
      countryName: 'Ecuador',
      alpha2Code: 'EC',
      numericCode: '218',
    },
    {
      '@id': '/api/country_infos/76',
      '@type': 'CountryInfo',
      id: 76,
      countryName: 'Egypt',
      alpha2Code: 'EG',
      numericCode: '818',
    },
    {
      '@id': '/api/country_infos/77',
      '@type': 'CountryInfo',
      id: 77,
      countryName: 'Equatorial Guinea',
      alpha2Code: 'GQ',
      numericCode: '226',
    },
    {
      '@id': '/api/country_infos/78',
      '@type': 'CountryInfo',
      id: 78,
      countryName: 'Eritrea',
      alpha2Code: 'ER',
      numericCode: '232',
    },
    {
      '@id': '/api/country_infos/79',
      '@type': 'CountryInfo',
      id: 79,
      countryName: 'Estonia',
      alpha2Code: 'EE',
      numericCode: '233',
    },
    {
      '@id': '/api/country_infos/80',
      '@type': 'CountryInfo',
      id: 80,
      countryName: 'Eswatini',
      alpha2Code: 'SZ',
      numericCode: '748',
    },
    {
      '@id': '/api/country_infos/81',
      '@type': 'CountryInfo',
      id: 81,
      countryName: 'Ethiopia',
      alpha2Code: 'ET',
      numericCode: '231',
    },
    {
      '@id': '/api/country_infos/82',
      '@type': 'CountryInfo',
      id: 82,
      countryName: 'Falkland Islands (the) [Malvinas]',
      alpha2Code: 'FK',
      numericCode: '238',
    },
    {
      '@id': '/api/country_infos/83',
      '@type': 'CountryInfo',
      id: 83,
      countryName: 'Faroe Islands (the)',
      alpha2Code: 'FO',
      numericCode: '234',
    },
    {
      '@id': '/api/country_infos/84',
      '@type': 'CountryInfo',
      id: 84,
      countryName: 'Fiji',
      alpha2Code: 'FJ',
      numericCode: '242',
    },
    {
      '@id': '/api/country_infos/85',
      '@type': 'CountryInfo',
      id: 85,
      countryName: 'Finland',
      alpha2Code: 'FI',
      numericCode: '246',
    },
    {
      '@id': '/api/country_infos/86',
      '@type': 'CountryInfo',
      id: 86,
      countryName: 'French Guiana',
      alpha2Code: 'GF',
      numericCode: '254',
    },
    {
      '@id': '/api/country_infos/87',
      '@type': 'CountryInfo',
      id: 87,
      countryName: 'French Polynesia',
      alpha2Code: 'PF',
      numericCode: '258',
    },
    {
      '@id': '/api/country_infos/88',
      '@type': 'CountryInfo',
      id: 88,
      countryName: 'French Southern Territories (the)',
      alpha2Code: 'TF',
      numericCode: '260',
    },
    {
      '@id': '/api/country_infos/89',
      '@type': 'CountryInfo',
      id: 89,
      countryName: 'Gabon',
      alpha2Code: 'GA',
      numericCode: '266',
    },
    {
      '@id': '/api/country_infos/90',
      '@type': 'CountryInfo',
      id: 90,
      countryName: 'Gambia (the)',
      alpha2Code: 'GM',
      numericCode: '270',
    },
    {
      '@id': '/api/country_infos/91',
      '@type': 'CountryInfo',
      id: 91,
      countryName: 'Georgia',
      alpha2Code: 'GE',
      numericCode: '268',
    },
    {
      '@id': '/api/country_infos/92',
      '@type': 'CountryInfo',
      id: 92,
      countryName: 'Ghana',
      alpha2Code: 'GH',
      numericCode: '288',
    },
    {
      '@id': '/api/country_infos/93',
      '@type': 'CountryInfo',
      id: 93,
      countryName: 'Gibraltar',
      alpha2Code: 'GI',
      numericCode: '292',
    },
    {
      '@id': '/api/country_infos/94',
      '@type': 'CountryInfo',
      id: 94,
      countryName: 'Greece',
      alpha2Code: 'GR',
      numericCode: '300',
    },
    {
      '@id': '/api/country_infos/95',
      '@type': 'CountryInfo',
      id: 95,
      countryName: 'Greenland',
      alpha2Code: 'GL',
      numericCode: '304',
    },
    {
      '@id': '/api/country_infos/96',
      '@type': 'CountryInfo',
      id: 96,
      countryName: 'Grenada',
      alpha2Code: 'GD',
      numericCode: '308',
    },
    {
      '@id': '/api/country_infos/97',
      '@type': 'CountryInfo',
      id: 97,
      countryName: 'Guadeloupe',
      alpha2Code: 'GP',
      numericCode: '312',
    },
    {
      '@id': '/api/country_infos/98',
      '@type': 'CountryInfo',
      id: 98,
      countryName: 'Guam',
      alpha2Code: 'GU',
      numericCode: '316',
    },
    {
      '@id': '/api/country_infos/99',
      '@type': 'CountryInfo',
      id: 99,
      countryName: 'Guernsey',
      alpha2Code: 'GG',
      numericCode: '831',
    },
    {
      '@id': '/api/country_infos/100',
      '@type': 'CountryInfo',
      id: 100,
      countryName: 'Guinea',
      alpha2Code: 'GN',
      numericCode: '324',
    },
    {
      '@id': '/api/country_infos/101',
      '@type': 'CountryInfo',
      id: 101,
      countryName: 'Guinea-Bissau',
      alpha2Code: 'GW',
      numericCode: '624',
    },
    {
      '@id': '/api/country_infos/102',
      '@type': 'CountryInfo',
      id: 102,
      countryName: 'Guyana',
      alpha2Code: 'GY',
      numericCode: '328',
    },
    {
      '@id': '/api/country_infos/103',
      '@type': 'CountryInfo',
      id: 103,
      countryName: 'Haiti',
      alpha2Code: 'HT',
      numericCode: '332',
    },
    {
      '@id': '/api/country_infos/104',
      '@type': 'CountryInfo',
      id: 104,
      countryName: 'Heard Island and McDonald Islands',
      alpha2Code: 'HM',
      numericCode: '334',
    },
    {
      '@id': '/api/country_infos/105',
      '@type': 'CountryInfo',
      id: 105,
      countryName: 'Holy See (the)',
      alpha2Code: 'VA',
      numericCode: '336',
    },
    {
      '@id': '/api/country_infos/106',
      '@type': 'CountryInfo',
      id: 106,
      countryName: 'Hong Kong',
      alpha2Code: 'HK',
      numericCode: '344',
    },
    {
      '@id': '/api/country_infos/107',
      '@type': 'CountryInfo',
      id: 107,
      countryName: 'Hungary',
      alpha2Code: 'HU',
      numericCode: '348',
    },
    {
      '@id': '/api/country_infos/108',
      '@type': 'CountryInfo',
      id: 108,
      countryName: 'Iceland',
      alpha2Code: 'IS',
      numericCode: '352',
    },
    {
      '@id': '/api/country_infos/109',
      '@type': 'CountryInfo',
      id: 109,
      countryName: 'India',
      alpha2Code: 'IN',
      numericCode: '356',
    },
    {
      '@id': '/api/country_infos/110',
      '@type': 'CountryInfo',
      id: 110,
      countryName: 'Indonesia',
      alpha2Code: 'ID',
      numericCode: '360',
    },
    {
      '@id': '/api/country_infos/111',
      '@type': 'CountryInfo',
      id: 111,
      countryName: 'Iran (Islamic Republic of)',
      alpha2Code: 'IR',
      numericCode: '364',
    },
    {
      '@id': '/api/country_infos/112',
      '@type': 'CountryInfo',
      id: 112,
      countryName: 'Iraq',
      alpha2Code: 'IQ',
      numericCode: '368',
    },
    {
      '@id': '/api/country_infos/113',
      '@type': 'CountryInfo',
      id: 113,
      countryName: 'Isle of Man',
      alpha2Code: 'IM',
      numericCode: '833',
    },
    {
      '@id': '/api/country_infos/114',
      '@type': 'CountryInfo',
      id: 114,
      countryName: 'Israel',
      alpha2Code: 'IL',
      numericCode: '376',
    },
    {
      '@id': '/api/country_infos/115',
      '@type': 'CountryInfo',
      id: 115,
      countryName: 'Italy',
      alpha2Code: 'IT',
      numericCode: '380',
    },
    {
      '@id': '/api/country_infos/116',
      '@type': 'CountryInfo',
      id: 116,
      countryName: 'Jamaica',
      alpha2Code: 'JM',
      numericCode: '388',
    },
    {
      '@id': '/api/country_infos/117',
      '@type': 'CountryInfo',
      id: 117,
      countryName: 'Japan',
      alpha2Code: 'JP',
      numericCode: '392',
    },
    {
      '@id': '/api/country_infos/118',
      '@type': 'CountryInfo',
      id: 118,
      countryName: 'Jersey',
      alpha2Code: 'JE',
      numericCode: '832',
    },
    {
      '@id': '/api/country_infos/119',
      '@type': 'CountryInfo',
      id: 119,
      countryName: 'Jordan',
      alpha2Code: 'JO',
      numericCode: '400',
    },
    {
      '@id': '/api/country_infos/120',
      '@type': 'CountryInfo',
      id: 120,
      countryName: 'Kazakhstan',
      alpha2Code: 'KZ',
      numericCode: '398',
    },
    {
      '@id': '/api/country_infos/121',
      '@type': 'CountryInfo',
      id: 121,
      countryName: 'Kenya',
      alpha2Code: 'KE',
      numericCode: '404',
    },
    {
      '@id': '/api/country_infos/122',
      '@type': 'CountryInfo',
      id: 122,
      countryName: 'Kiribati',
      alpha2Code: 'KI',
      numericCode: '296',
    },
    {
      '@id': '/api/country_infos/123',
      '@type': 'CountryInfo',
      id: 123,
      countryName: "Korea (the Democratic People's Republic of)",
      alpha2Code: 'KP',
      numericCode: '408',
    },
    {
      '@id': '/api/country_infos/124',
      '@type': 'CountryInfo',
      id: 124,
      countryName: 'Korea (the Republic of)',
      alpha2Code: 'KR',
      numericCode: '410',
    },
    {
      '@id': '/api/country_infos/125',
      '@type': 'CountryInfo',
      id: 125,
      countryName: 'Kuwait',
      alpha2Code: 'KW',
      numericCode: '414',
    },
    {
      '@id': '/api/country_infos/126',
      '@type': 'CountryInfo',
      id: 126,
      countryName: 'Kyrgyzstan',
      alpha2Code: 'KG',
      numericCode: '417',
    },
    {
      '@id': '/api/country_infos/127',
      '@type': 'CountryInfo',
      id: 127,
      countryName: "Lao People's Democratic Republic (the)",
      alpha2Code: 'LA',
      numericCode: '418',
    },
    {
      '@id': '/api/country_infos/128',
      '@type': 'CountryInfo',
      id: 128,
      countryName: 'Latvia',
      alpha2Code: 'LV',
      numericCode: '428',
    },
    {
      '@id': '/api/country_infos/129',
      '@type': 'CountryInfo',
      id: 129,
      countryName: 'Lebanon',
      alpha2Code: 'LB',
      numericCode: '422',
    },
    {
      '@id': '/api/country_infos/130',
      '@type': 'CountryInfo',
      id: 130,
      countryName: 'Lesotho',
      alpha2Code: 'LS',
      numericCode: '426',
    },
    {
      '@id': '/api/country_infos/131',
      '@type': 'CountryInfo',
      id: 131,
      countryName: 'Liberia',
      alpha2Code: 'LR',
      numericCode: '430',
    },
    {
      '@id': '/api/country_infos/132',
      '@type': 'CountryInfo',
      id: 132,
      countryName: 'Libya',
      alpha2Code: 'LY',
      numericCode: '434',
    },
    {
      '@id': '/api/country_infos/133',
      '@type': 'CountryInfo',
      id: 133,
      countryName: 'Liechtenstein',
      alpha2Code: 'LI',
      numericCode: '438',
    },
    {
      '@id': '/api/country_infos/134',
      '@type': 'CountryInfo',
      id: 134,
      countryName: 'Lithuania',
      alpha2Code: 'LT',
      numericCode: '440',
    },
    {
      '@id': '/api/country_infos/135',
      '@type': 'CountryInfo',
      id: 135,
      countryName: 'Luxembourg',
      alpha2Code: 'LU',
      numericCode: '442',
    },
    {
      '@id': '/api/country_infos/136',
      '@type': 'CountryInfo',
      id: 136,
      countryName: 'Macao',
      alpha2Code: 'MO',
      numericCode: '446',
    },
    {
      '@id': '/api/country_infos/137',
      '@type': 'CountryInfo',
      id: 137,
      countryName: 'Madagascar',
      alpha2Code: 'MG',
      numericCode: '450',
    },
    {
      '@id': '/api/country_infos/138',
      '@type': 'CountryInfo',
      id: 138,
      countryName: 'Malawi',
      alpha2Code: 'MW',
      numericCode: '454',
    },
    {
      '@id': '/api/country_infos/139',
      '@type': 'CountryInfo',
      id: 139,
      countryName: 'Malaysia',
      alpha2Code: 'MY',
      numericCode: '458',
    },
    {
      '@id': '/api/country_infos/140',
      '@type': 'CountryInfo',
      id: 140,
      countryName: 'Maldives',
      alpha2Code: 'MV',
      numericCode: '462',
    },
    {
      '@id': '/api/country_infos/141',
      '@type': 'CountryInfo',
      id: 141,
      countryName: 'Mali',
      alpha2Code: 'ML',
      numericCode: '466',
    },
    {
      '@id': '/api/country_infos/142',
      '@type': 'CountryInfo',
      id: 142,
      countryName: 'Malta',
      alpha2Code: 'MT',
      numericCode: '470',
    },
    {
      '@id': '/api/country_infos/143',
      '@type': 'CountryInfo',
      id: 143,
      countryName: 'Marshall Islands (the)',
      alpha2Code: 'MH',
      numericCode: '584',
    },
    {
      '@id': '/api/country_infos/144',
      '@type': 'CountryInfo',
      id: 144,
      countryName: 'Martinique',
      alpha2Code: 'MQ',
      numericCode: '474',
    },
    {
      '@id': '/api/country_infos/145',
      '@type': 'CountryInfo',
      id: 145,
      countryName: 'Mauritania',
      alpha2Code: 'MR',
      numericCode: '478',
    },
    {
      '@id': '/api/country_infos/146',
      '@type': 'CountryInfo',
      id: 146,
      countryName: 'Mauritius',
      alpha2Code: 'MU',
      numericCode: '480',
    },
    {
      '@id': '/api/country_infos/147',
      '@type': 'CountryInfo',
      id: 147,
      countryName: 'Mayotte',
      alpha2Code: 'YT',
      numericCode: '175',
    },
    {
      '@id': '/api/country_infos/148',
      '@type': 'CountryInfo',
      id: 148,
      countryName: 'Micronesia (Federated States of)',
      alpha2Code: 'FM',
      numericCode: '583',
    },
    {
      '@id': '/api/country_infos/149',
      '@type': 'CountryInfo',
      id: 149,
      countryName: 'Moldova (the Republic of)',
      alpha2Code: 'MD',
      numericCode: '498',
    },
    {
      '@id': '/api/country_infos/150',
      '@type': 'CountryInfo',
      id: 150,
      countryName: 'Monaco',
      alpha2Code: 'MC',
      numericCode: '492',
    },
    {
      '@id': '/api/country_infos/151',
      '@type': 'CountryInfo',
      id: 151,
      countryName: 'Mongolia',
      alpha2Code: 'MN',
      numericCode: '496',
    },
    {
      '@id': '/api/country_infos/152',
      '@type': 'CountryInfo',
      id: 152,
      countryName: 'Montenegro',
      alpha2Code: 'ME',
      numericCode: '499',
    },
    {
      '@id': '/api/country_infos/153',
      '@type': 'CountryInfo',
      id: 153,
      countryName: 'Montserrat',
      alpha2Code: 'MS',
      numericCode: '500',
    },
    {
      '@id': '/api/country_infos/154',
      '@type': 'CountryInfo',
      id: 154,
      countryName: 'Morocco',
      alpha2Code: 'MA',
      numericCode: '504',
    },
    {
      '@id': '/api/country_infos/155',
      '@type': 'CountryInfo',
      id: 155,
      countryName: 'Mozambique',
      alpha2Code: 'MZ',
      numericCode: '508',
    },
    {
      '@id': '/api/country_infos/156',
      '@type': 'CountryInfo',
      id: 156,
      countryName: 'Myanmar',
      alpha2Code: 'MM',
      numericCode: '104',
    },
    {
      '@id': '/api/country_infos/157',
      '@type': 'CountryInfo',
      id: 157,
      countryName: 'Namibia',
      alpha2Code: 'NA',
      numericCode: '516',
    },
    {
      '@id': '/api/country_infos/158',
      '@type': 'CountryInfo',
      id: 158,
      countryName: 'Nauru',
      alpha2Code: 'NR',
      numericCode: '520',
    },
    {
      '@id': '/api/country_infos/159',
      '@type': 'CountryInfo',
      id: 159,
      countryName: 'Nepal',
      alpha2Code: 'NP',
      numericCode: '524',
    },
    {
      '@id': '/api/country_infos/160',
      '@type': 'CountryInfo',
      id: 160,
      countryName: 'Netherlands (the)',
      alpha2Code: 'NL',
      numericCode: '528',
    },
    {
      '@id': '/api/country_infos/161',
      '@type': 'CountryInfo',
      id: 161,
      countryName: 'New Caledonia',
      alpha2Code: 'NC',
      numericCode: '540',
    },
    {
      '@id': '/api/country_infos/162',
      '@type': 'CountryInfo',
      id: 162,
      countryName: 'New Zealand',
      alpha2Code: 'NZ',
      numericCode: '554',
    },
    {
      '@id': '/api/country_infos/163',
      '@type': 'CountryInfo',
      id: 163,
      countryName: 'Niger (the)',
      alpha2Code: 'NE',
      numericCode: '562',
    },
    {
      '@id': '/api/country_infos/164',
      '@type': 'CountryInfo',
      id: 164,
      countryName: 'Nigeria',
      alpha2Code: 'NG',
      numericCode: '566',
    },
    {
      '@id': '/api/country_infos/165',
      '@type': 'CountryInfo',
      id: 165,
      countryName: 'Niue',
      alpha2Code: 'NU',
      numericCode: '570',
    },
    {
      '@id': '/api/country_infos/166',
      '@type': 'CountryInfo',
      id: 166,
      countryName: 'Norfolk Island',
      alpha2Code: 'NF',
      numericCode: '574',
    },
    {
      '@id': '/api/country_infos/167',
      '@type': 'CountryInfo',
      id: 167,
      countryName: 'Northern Mariana Islands (the)',
      alpha2Code: 'MP',
      numericCode: '580',
    },
    {
      '@id': '/api/country_infos/168',
      '@type': 'CountryInfo',
      id: 168,
      countryName: 'Norway',
      alpha2Code: 'NO',
      numericCode: '578',
    },
    {
      '@id': '/api/country_infos/169',
      '@type': 'CountryInfo',
      id: 169,
      countryName: 'Oman',
      alpha2Code: 'OM',
      numericCode: '512',
    },
    {
      '@id': '/api/country_infos/170',
      '@type': 'CountryInfo',
      id: 170,
      countryName: 'Pakistan',
      alpha2Code: 'PK',
      numericCode: '586',
    },
    {
      '@id': '/api/country_infos/171',
      '@type': 'CountryInfo',
      id: 171,
      countryName: 'Palau',
      alpha2Code: 'PW',
      numericCode: '585',
    },
    {
      '@id': '/api/country_infos/172',
      '@type': 'CountryInfo',
      id: 172,
      countryName: 'Palestine, State of',
      alpha2Code: 'PS',
      numericCode: '275',
    },
    {
      '@id': '/api/country_infos/173',
      '@type': 'CountryInfo',
      id: 173,
      countryName: 'Papua New Guinea',
      alpha2Code: 'PG',
      numericCode: '598',
    },
    {
      '@id': '/api/country_infos/174',
      '@type': 'CountryInfo',
      id: 174,
      countryName: 'Paraguay',
      alpha2Code: 'PY',
      numericCode: '600',
    },
    {
      '@id': '/api/country_infos/175',
      '@type': 'CountryInfo',
      id: 175,
      countryName: 'Philippines (the)',
      alpha2Code: 'PH',
      numericCode: '608',
    },
    {
      '@id': '/api/country_infos/176',
      '@type': 'CountryInfo',
      id: 176,
      countryName: 'Pitcairn',
      alpha2Code: 'PN',
      numericCode: '612',
    },
    {
      '@id': '/api/country_infos/177',
      '@type': 'CountryInfo',
      id: 177,
      countryName: 'Poland',
      alpha2Code: 'PL',
      numericCode: '616',
    },
    {
      '@id': '/api/country_infos/178',
      '@type': 'CountryInfo',
      id: 178,
      countryName: 'Portugal',
      alpha2Code: 'PT',
      numericCode: '620',
    },
    {
      '@id': '/api/country_infos/179',
      '@type': 'CountryInfo',
      id: 179,
      countryName: 'Puerto Rico',
      alpha2Code: 'PR',
      numericCode: '630',
    },
    {
      '@id': '/api/country_infos/180',
      '@type': 'CountryInfo',
      id: 180,
      countryName: 'Qatar',
      alpha2Code: 'QA',
      numericCode: '634',
    },
    {
      '@id': '/api/country_infos/181',
      '@type': 'CountryInfo',
      id: 181,
      countryName: 'Republic of North Macedonia',
      alpha2Code: 'MK',
      numericCode: '807',
    },
    {
      '@id': '/api/country_infos/182',
      '@type': 'CountryInfo',
      id: 182,
      countryName: 'Romania',
      alpha2Code: 'RO',
      numericCode: '642',
    },
    {
      '@id': '/api/country_infos/183',
      '@type': 'CountryInfo',
      id: 183,
      countryName: 'Russian Federation (the)',
      alpha2Code: 'RU',
      numericCode: '643',
    },
    {
      '@id': '/api/country_infos/184',
      '@type': 'CountryInfo',
      id: 184,
      countryName: 'Rwanda',
      alpha2Code: 'RW',
      numericCode: '646',
    },
    {
      '@id': '/api/country_infos/185',
      '@type': 'CountryInfo',
      id: 185,
      countryName: 'Réunion',
      alpha2Code: 'RE',
      numericCode: '638',
    },
    {
      '@id': '/api/country_infos/186',
      '@type': 'CountryInfo',
      id: 186,
      countryName: 'Saint Barthélemy',
      alpha2Code: 'BL',
      numericCode: '652',
    },
    {
      '@id': '/api/country_infos/187',
      '@type': 'CountryInfo',
      id: 187,
      countryName: 'Saint Helena, Ascension and Tristan da Cunha',
      alpha2Code: 'SH',
      numericCode: '654',
    },
    {
      '@id': '/api/country_infos/188',
      '@type': 'CountryInfo',
      id: 188,
      countryName: 'Saint Kitts and Nevis',
      alpha2Code: 'KN',
      numericCode: '659',
    },
    {
      '@id': '/api/country_infos/189',
      '@type': 'CountryInfo',
      id: 189,
      countryName: 'Saint Lucia',
      alpha2Code: 'LC',
      numericCode: '662',
    },
    {
      '@id': '/api/country_infos/190',
      '@type': 'CountryInfo',
      id: 190,
      countryName: 'Saint Martin (French part)',
      alpha2Code: 'MF',
      numericCode: '663',
    },
    {
      '@id': '/api/country_infos/191',
      '@type': 'CountryInfo',
      id: 191,
      countryName: 'Saint Pierre and Miquelon',
      alpha2Code: 'PM',
      numericCode: '666',
    },
    {
      '@id': '/api/country_infos/192',
      '@type': 'CountryInfo',
      id: 192,
      countryName: 'Saint Vincent and the Grenadines',
      alpha2Code: 'VC',
      numericCode: '670',
    },
    {
      '@id': '/api/country_infos/193',
      '@type': 'CountryInfo',
      id: 193,
      countryName: 'Samoa',
      alpha2Code: 'WS',
      numericCode: '882',
    },
    {
      '@id': '/api/country_infos/194',
      '@type': 'CountryInfo',
      id: 194,
      countryName: 'San Marino',
      alpha2Code: 'SM',
      numericCode: '674',
    },
    {
      '@id': '/api/country_infos/195',
      '@type': 'CountryInfo',
      id: 195,
      countryName: 'Sao Tome and Principe',
      alpha2Code: 'ST',
      numericCode: '678',
    },
    {
      '@id': '/api/country_infos/196',
      '@type': 'CountryInfo',
      id: 196,
      countryName: 'Saudi Arabia',
      alpha2Code: 'SA',
      numericCode: '682',
    },
    {
      '@id': '/api/country_infos/197',
      '@type': 'CountryInfo',
      id: 197,
      countryName: 'Senegal',
      alpha2Code: 'SN',
      numericCode: '686',
    },
    {
      '@id': '/api/country_infos/198',
      '@type': 'CountryInfo',
      id: 198,
      countryName: 'Serbia',
      alpha2Code: 'RS',
      numericCode: '688',
    },
    {
      '@id': '/api/country_infos/199',
      '@type': 'CountryInfo',
      id: 199,
      countryName: 'Seychelles',
      alpha2Code: 'SC',
      numericCode: '690',
    },
    {
      '@id': '/api/country_infos/200',
      '@type': 'CountryInfo',
      id: 200,
      countryName: 'Sierra Leone',
      alpha2Code: 'SL',
      numericCode: '694',
    },
    {
      '@id': '/api/country_infos/201',
      '@type': 'CountryInfo',
      id: 201,
      countryName: 'Singapore',
      alpha2Code: 'SG',
      numericCode: '702',
    },
    {
      '@id': '/api/country_infos/202',
      '@type': 'CountryInfo',
      id: 202,
      countryName: 'Sint Maarten (Dutch part)',
      alpha2Code: 'SX',
      numericCode: '534',
    },
    {
      '@id': '/api/country_infos/203',
      '@type': 'CountryInfo',
      id: 203,
      countryName: 'Slovakia',
      alpha2Code: 'SK',
      numericCode: '703',
    },
    {
      '@id': '/api/country_infos/204',
      '@type': 'CountryInfo',
      id: 204,
      countryName: 'Slovenia',
      alpha2Code: 'SI',
      numericCode: '705',
    },
    {
      '@id': '/api/country_infos/205',
      '@type': 'CountryInfo',
      id: 205,
      countryName: 'Solomon Islands',
      alpha2Code: 'SB',
      numericCode: '090',
    },
    {
      '@id': '/api/country_infos/206',
      '@type': 'CountryInfo',
      id: 206,
      countryName: 'Somalia',
      alpha2Code: 'SO',
      numericCode: '706',
    },
    {
      '@id': '/api/country_infos/207',
      '@type': 'CountryInfo',
      id: 207,
      countryName: 'South Africa',
      alpha2Code: 'ZA',
      numericCode: '710',
    },
    {
      '@id': '/api/country_infos/208',
      '@type': 'CountryInfo',
      id: 208,
      countryName: 'South Georgia and the South Sandwich Islands',
      alpha2Code: 'GS',
      numericCode: '239',
    },
    {
      '@id': '/api/country_infos/209',
      '@type': 'CountryInfo',
      id: 209,
      countryName: 'South Sudan',
      alpha2Code: 'SS',
      numericCode: '728',
    },
    {
      '@id': '/api/country_infos/210',
      '@type': 'CountryInfo',
      id: 210,
      countryName: 'Spain',
      alpha2Code: 'ES',
      numericCode: '724',
    },
    {
      '@id': '/api/country_infos/211',
      '@type': 'CountryInfo',
      id: 211,
      countryName: 'Sri Lanka',
      alpha2Code: 'LK',
      numericCode: '144',
    },
    {
      '@id': '/api/country_infos/212',
      '@type': 'CountryInfo',
      id: 212,
      countryName: 'Sudan (the)',
      alpha2Code: 'SD',
      numericCode: '729',
    },
    {
      '@id': '/api/country_infos/213',
      '@type': 'CountryInfo',
      id: 213,
      countryName: 'Suriname',
      alpha2Code: 'SR',
      numericCode: '740',
    },
    {
      '@id': '/api/country_infos/214',
      '@type': 'CountryInfo',
      id: 214,
      countryName: 'Svalbard and Jan Mayen',
      alpha2Code: 'SJ',
      numericCode: '744',
    },
    {
      '@id': '/api/country_infos/215',
      '@type': 'CountryInfo',
      id: 215,
      countryName: 'Sweden',
      alpha2Code: 'SE',
      numericCode: '752',
    },
    {
      '@id': '/api/country_infos/216',
      '@type': 'CountryInfo',
      id: 216,
      countryName: 'Switzerland',
      alpha2Code: 'CH',
      numericCode: '756',
    },
    {
      '@id': '/api/country_infos/217',
      '@type': 'CountryInfo',
      id: 217,
      countryName: 'Syrian Arab Republic',
      alpha2Code: 'SY',
      numericCode: '760',
    },
    {
      '@id': '/api/country_infos/218',
      '@type': 'CountryInfo',
      id: 218,
      countryName: 'Taiwan (Province of China)',
      alpha2Code: 'TW',
      numericCode: '158',
    },
    {
      '@id': '/api/country_infos/219',
      '@type': 'CountryInfo',
      id: 219,
      countryName: 'Tajikistan',
      alpha2Code: 'TJ',
      numericCode: '762',
    },
    {
      '@id': '/api/country_infos/220',
      '@type': 'CountryInfo',
      id: 220,
      countryName: 'Tanzania, United Republic of',
      alpha2Code: 'TZ',
      numericCode: '834',
    },
    {
      '@id': '/api/country_infos/221',
      '@type': 'CountryInfo',
      id: 221,
      countryName: 'Thailand',
      alpha2Code: 'TH',
      numericCode: '764',
    },
    {
      '@id': '/api/country_infos/222',
      '@type': 'CountryInfo',
      id: 222,
      countryName: 'Timor-Leste',
      alpha2Code: 'TL',
      numericCode: '626',
    },
    {
      '@id': '/api/country_infos/223',
      '@type': 'CountryInfo',
      id: 223,
      countryName: 'Togo',
      alpha2Code: 'TG',
      numericCode: '768',
    },
    {
      '@id': '/api/country_infos/224',
      '@type': 'CountryInfo',
      id: 224,
      countryName: 'Tokelau',
      alpha2Code: 'TK',
      numericCode: '772',
    },
    {
      '@id': '/api/country_infos/225',
      '@type': 'CountryInfo',
      id: 225,
      countryName: 'Tonga',
      alpha2Code: 'TO',
      numericCode: '776',
    },
    {
      '@id': '/api/country_infos/226',
      '@type': 'CountryInfo',
      id: 226,
      countryName: 'Trinidad and Tobago',
      alpha2Code: 'TT',
      numericCode: '780',
    },
    {
      '@id': '/api/country_infos/227',
      '@type': 'CountryInfo',
      id: 227,
      countryName: 'Tunisia',
      alpha2Code: 'TN',
      numericCode: '788',
    },
    {
      '@id': '/api/country_infos/228',
      '@type': 'CountryInfo',
      id: 228,
      countryName: 'Turkey',
      alpha2Code: 'TR',
      numericCode: '792',
    },
    {
      '@id': '/api/country_infos/229',
      '@type': 'CountryInfo',
      id: 229,
      countryName: 'Turkmenistan',
      alpha2Code: 'TM',
      numericCode: '795',
    },
    {
      '@id': '/api/country_infos/230',
      '@type': 'CountryInfo',
      id: 230,
      countryName: 'Turks and Caicos Islands (the)',
      alpha2Code: 'TC',
      numericCode: '796',
    },
    {
      '@id': '/api/country_infos/231',
      '@type': 'CountryInfo',
      id: 231,
      countryName: 'Tuvalu',
      alpha2Code: 'TV',
      numericCode: '798',
    },
    {
      '@id': '/api/country_infos/232',
      '@type': 'CountryInfo',
      id: 232,
      countryName: 'Uganda',
      alpha2Code: 'UG',
      numericCode: '800',
    },
    {
      '@id': '/api/country_infos/233',
      '@type': 'CountryInfo',
      id: 233,
      countryName: 'Ukraine',
      alpha2Code: 'UA',
      numericCode: '804',
    },
    {
      '@id': '/api/country_infos/234',
      '@type': 'CountryInfo',
      id: 234,
      countryName: 'United Arab Emirates (the)',
      alpha2Code: 'AE',
      numericCode: '784',
    },
    {
      '@id': '/api/country_infos/235',
      '@type': 'CountryInfo',
      id: 235,
      countryName: 'United States Minor Outlying Islands (the)',
      alpha2Code: 'UM',
      numericCode: '581',
    },
    {
      '@id': '/api/country_infos/236',
      '@type': 'CountryInfo',
      id: 236,
      countryName: 'Uruguay',
      alpha2Code: 'UY',
      numericCode: '858',
    },
    {
      '@id': '/api/country_infos/237',
      '@type': 'CountryInfo',
      id: 237,
      countryName: 'Uzbekistan',
      alpha2Code: 'UZ',
      numericCode: '860',
    },
    {
      '@id': '/api/country_infos/238',
      '@type': 'CountryInfo',
      id: 238,
      countryName: 'Vanuatu',
      alpha2Code: 'VU',
      numericCode: '548',
    },
    {
      '@id': '/api/country_infos/239',
      '@type': 'CountryInfo',
      id: 239,
      countryName: 'Venezuela (Bolivarian Republic of)',
      alpha2Code: 'VE',
      numericCode: '862',
    },
    {
      '@id': '/api/country_infos/240',
      '@type': 'CountryInfo',
      id: 240,
      countryName: 'Viet Nam',
      alpha2Code: 'VN',
      numericCode: '704',
    },
    {
      '@id': '/api/country_infos/241',
      '@type': 'CountryInfo',
      id: 241,
      countryName: 'Virgin Islands (British)',
      alpha2Code: 'VG',
      numericCode: '092',
    },
    {
      '@id': '/api/country_infos/242',
      '@type': 'CountryInfo',
      id: 242,
      countryName: 'Virgin Islands (U.S.)',
      alpha2Code: 'VI',
      numericCode: '850',
    },
    {
      '@id': '/api/country_infos/243',
      '@type': 'CountryInfo',
      id: 243,
      countryName: 'Wallis and Futuna',
      alpha2Code: 'WF',
      numericCode: '876',
    },
    {
      '@id': '/api/country_infos/244',
      '@type': 'CountryInfo',
      id: 244,
      countryName: 'Western Sahara',
      alpha2Code: 'EH',
      numericCode: '732',
    },
    {
      '@id': '/api/country_infos/245',
      '@type': 'CountryInfo',
      id: 245,
      countryName: 'Yemen',
      alpha2Code: 'YE',
      numericCode: '887',
    },
    {
      '@id': '/api/country_infos/246',
      '@type': 'CountryInfo',
      id: 246,
      countryName: 'Zambia',
      alpha2Code: 'ZM',
      numericCode: '894',
    },
    {
      '@id': '/api/country_infos/247',
      '@type': 'CountryInfo',
      id: 247,
      countryName: 'Zimbabwe',
      alpha2Code: 'ZW',
      numericCode: '716',
    },
    {
      '@id': '/api/country_infos/248',
      '@type': 'CountryInfo',
      id: 248,
      countryName: 'Åland Islands',
      alpha2Code: 'AX',
      numericCode: '248',
    },
  ],
};
